import './App.css';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from './pages/Home/Home';
import Header from './pages/Header/Header';
import Footer from './pages/Footer/Footer';
import NotFound from './pages/NotFound/NotFound';
import Tour from './pages/Tour/Tour';
import Blog from './pages/Blog/Blog';
import Shop from './pages/Shop/Shop';
import Contact from './pages/Contact/Contact';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import AuthProvider from './context/AuthProvider';
import PrivateRoute from './pages/PrivateRoute/PrivateRoute';
import Order from './pages/Order/Order';
import TourItem from './pages/TourItem/TourItem';
import AddItem from './pages/AddItem/AddItem';

function App() {
  return (
    <div className="App">
    <AuthProvider>
      <BrowserRouter>
      <Header></Header>
        <Switch>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route path="/tour">
            <Tour></Tour>
          </Route>
          <Route path="/blog">
            <Blog></Blog>
          </Route>
          <Route path="/shop">
            <Shop></Shop>
          </Route>
          <Route path="/order">
            <Order></Order>
          </Route>
          <Route path="/contact">
            <Contact></Contact>
          </Route>
          <Route path="/login">
            <Login></Login>
          </Route>
          <Route path="/register">
            <Register></Register>
          </Route>
          <PrivateRoute path="/tourItem">
            <TourItem></TourItem>
          </PrivateRoute>
          <Route path="/addItem">
            <AddItem></AddItem>
          </Route>
          <Route path="*">
            <NotFound></NotFound>
          </Route>
        </Switch>
        <Footer></Footer>
      </BrowserRouter>
    </AuthProvider>
    </div>
  );
}

export default App;
